import script from "./personal-information-editing-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./personal-information-editing-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./personal-information-editing-drawer.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__